import g from '../assets/img/casas/g.png';
import s from '../assets/img/casas/s.png';
import h from '../assets/img/casas/h.png';
import r from '../assets/img/casas/r.png';


import o from '../assets/img/oro.png';
import p from '../assets/img/plata.png';
import b from '../assets/img/bronce.png';
import sn from '../assets/img/snitch.png';

export function casaIc(casa) {
    switch (casa) {
        case "GRYFFINDOR":
            return g;

        case "HUFFLEPUFF":
            return h;

        case "RAVENCLAW":
            return r;

        case "SLYTHERIN":
            return s;

    }
}

export function medalla(lugar) {
    switch (lugar) {
        case 1:
            return o;

        case 2:
            return p;

        case 3:
            return b;

        default:
            return sn;

    }
}

export function casaFrase(casa) {
    let frase;
    switch (casa) {
        case "GRYFFINDOR":
            frase = "Valor, Fuerza y Audacia";
            break;
        case "HUFFLEPUFF":
            frase = "Justicia, Lealtad y Paciencia";
            break;
        case "RAVENCLAW":
            frase = "Creatividad, Erudición e Inteligencia";
            break;
        case "SLYTHERIN":
            frase = "Ambición, Determinación y Astucia";
            break;
    }
    return frase;
}

export function casaGradient(casa) {
    let gradient=[2];
    switch (casa) {
        case "GRYFFINDOR":
            gradient.push("#740001")
            gradient.push("#eeba30")

            break;
        case "HUFFLEPUFF":

            gradient.push("#CD9C27")
            gradient.push("#726255")

            break;
        case "RAVENCLAW":

            gradient.push("#0E1A40")
            gradient.push("#7E7E7E")

            break;
        case "SLYTHERIN":
            gradient.push("#2A623D")
            gradient.push("#232721")

            break;
    }
    return gradient;
}